import { colorAttentionBlue50, colorFunctionalGray30, iconSizeL, spacingL, } from "@rhumbix/rmbx_design_system_design_tokens";
import React from "react";
import Toggle from "react-switch";
/**
 * @param {boolean} checked Controls the checked state of the toggle
 * @param {function} onChange The change handler for the toggle
 * @param {boolean} disabled Sets the disabled state of the toggle
 * @param {string} arialabelledby Sets the ID of the label that identifies this toggle
 * @param {string} arialabel Sets a label to attach to the toggle for screen readers
 * @returns
 */
export const SlideToggle = (props) => (React.createElement(Toggle, { checked: props.checked, onChange: props.onChange, disabled: props.disabled, onColor: colorAttentionBlue50, offColor: colorFunctionalGray30, checkedIcon: false, uncheckedIcon: false, height: parseInt(iconSizeL), width: parseInt(spacingL), name: props.name, "aria-label": props.arialabel }));
export default SlideToggle;
